import Lightbox from "yet-another-react-lightbox"
import Zoom from "yet-another-react-lightbox/plugins/zoom"
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails"
import React from 'react'
import "yet-another-react-lightbox/styles.css"
import "yet-another-react-lightbox/plugins/thumbnails.css"

type Props = {
  imageIds: number[]
  showImageId?: number,
  onClose?: () => void
}

const ImageViewer = (props: Props) => {
  const nextImageUrl = (imageId: number, width: number) => {
    const src = `${process.env.NEXT_PUBLIC_API}/images/${imageId}`
    return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=75`
  }

  // get image index from imageIds bbased on showImageId
  const imageIndex = props.imageIds.findIndex((imageId) => imageId === props.showImageId)

  const imageSizes = [16, 32, 48, 64, 96, 128, 256, 384]
  const deviceSizes = [640, 750, 828, 1080, 1200, 1920, 2048, 3840]

  const width = 1200
  const height = 1200

  const slides = props.imageIds.map(imageId => ({
    width: 0,
    height: 0,
    src: nextImageUrl(imageId, width),
    srcSet: imageSizes
      .concat(...deviceSizes)
      .filter((size) => size <= width)
      .map((size) => ({
        src: nextImageUrl(imageId, size),
        width: size,
        height: Math.round((height / width) * size),
      })),
  }))

  return (
    <div>
      <Lightbox
        open={imageIndex >= 0}
        index={imageIndex}
        close={() => props.onClose?.()}
        slides={slides}
        plugins={[Zoom, Thumbnails]}
        thumbnails={{
          position: 'bottom',
          width: 120,
          height: 80,
          border: 0,
          borderRadius: 0,
          padding: 0,
          gap: 0,
          showToggle: false,
        }}
      />
    </div>
  )
}

export default ImageViewer